import {
	DOCUMENT_LIBRARY_ELEMENT_ID,
	makeComplexDataTestId,
} from '@dealstack/shared/tests/testElementIds';
import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { createUnitsColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/UnitsColumn.tsx';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { FindRelatedDocumentsRes } from '@dealstack/shared/lib/generated';
import { Button } from '@mantine/core';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const getRelatedToColumns: ({
	tCapManage,
	toggleRelatedRow,
}: {
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>;
	toggleRelatedRow: (index: string) => void;
}) => ExtendedColumnDef<FindRelatedDocumentsRes>[] = ({ tCapManage, toggleRelatedRow }) => [
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.transaction_date'),
		accessorKey: 'transactionDate',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.security_name'),
		accessorKey: 'securityName',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.transaction_type'),
		accessorKey: 'transactionType',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.buyer'),
		accessorKey: 'buyerName',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.seller'),
		accessorKey: 'sellerName',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createUnitsColumn({
		headerText: tCapManage('document.related_to.columns.number_of_units'),
		accessorKey: 'units',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	createTextColumn({
		headerText: tCapManage('document.related_to.columns.transaction_cost'),
		accessorKey: 'cost',
		enableGlobalFilter: false,
		enableSorting: false,
	}),
	{
		headerText: tCapManage('document.related_to.columns.action'),
		id: 'toggleRelatedTo',
		accessorKey: 'transactionId',
		cell: ({ row }) => {
			return (
				<Button
					data-testid={makeComplexDataTestId(
						DOCUMENT_LIBRARY_ELEMENT_ID.RELATED_TO_LINK_BUTTON,
						row.original.transactionId
					)}
					variant="outline"
					onClick={() => toggleRelatedRow(row.original.transactionId)}
				>
					{row.original.isLinkedToEntity
						? tCapManage('document.related_to.actions.unlink')
						: tCapManage('document.related_to.actions.link')}
				</Button>
			);
		},
		enableSorting: false,
		enableColumnActions: false,
	},
];
